export default __webpack_public_path__ + "static/media/dot_1.c1ad70e8.svg";